/* =========================================================
   NORTH — Premium Shopify OS 2.0 Theme — core JS
   No build step required. Vanilla JS, progressively enhances
   the Liquid-rendered markup.
========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------------- Utilities ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, sel, handler) {
    if (!el) return;
    if (typeof sel === 'function') { el.addEventListener(evt, sel); return; }
    el.addEventListener(evt, function (e) {
      var target = e.target.closest(sel);
      if (target && el.contains(target)) handler(e, target);
    });
  }
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace('{{amount}}', value);
  }
  /* Button labels: drop ".00" on whole-dollar prices ($39.00 -> $39); fractional prices are untouched. */
  function shortMoney(cents, format) {
    return formatMoney(cents, format).replace(/([.,])00(?!\d)/, '');
  }

  /* ---------------- Header scroll behaviour ---------------- */
  (function headerScroll() {
    var header = qs('.site-header');
    if (!header) return;
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (y > lastY && y > 160) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastY = y;
    }, { passive: true });
  })();

  /* ---------------- Announcement bar dismiss ---------------- */
  on(document, 'click', '.announcement-bar__close', function (e, btn) {
    var bar = btn.closest('.announcement-bar');
    if (bar) {
      bar.style.display = 'none';
      try { sessionStorage.setItem('north-announcement-dismissed', '1'); } catch (err) {}
    }
  });
  (function () {
    try {
      if (sessionStorage.getItem('north-announcement-dismissed')) {
        var bar = qs('.announcement-bar');
        if (bar) bar.style.display = 'none';
      }
    } catch (err) {}
  })();

  /* ---------------- Generic drawer open/close (cart, mobile nav, filters) ---------------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    var overlay = qs('[data-drawer-overlay="' + drawer.dataset.drawer + '"]') || qs('.drawer__overlay');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    qsa('.drawer__overlay').forEach(function (o) { o.classList.remove('is-open'); });
    document.body.classList.remove('no-scroll');
  }
  on(document, 'click', '[data-open-drawer]', function (e, btn) {
    e.preventDefault();
    openDrawer(qs('#' + btn.dataset.openDrawer));
  });
  on(document, 'click', '[data-close-drawer]', function (e, btn) {
    closeDrawer(btn.closest('.drawer'));
  });
  on(document, 'click', '.drawer__overlay', function () {
    qsa('.drawer.is-open').forEach(closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------------- Mobile nav accordion ---------------- */
  on(document, 'click', '[data-mobile-nav-trigger]', function (e, btn) {
    e.preventDefault();
    var sub = document.getElementById(btn.dataset.mobileNavTrigger);
    if (sub) sub.classList.toggle('is-open');
    btn.classList.toggle('is-open');
  });

  /* ---------------- Accordion (FAQ, product info) ---------------- */
  on(document, 'click', '.accordion-item__trigger', function (e, trigger) {
    var item = trigger.closest('.accordion-item');
    var panel = qs('.accordion-item__panel', item);
    var isOpen = item.classList.contains('is-open');
    var singleOpen = item.closest('[data-accordion-single]');
    if (singleOpen) {
      qsa('.accordion-item.is-open', singleOpen).forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          qs('.accordion-item__panel', openItem).style.maxHeight = null;
        }
      });
    }
    item.classList.toggle('is-open', !isOpen);
    panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : null;
  });

  /* ---------------- Hero slideshow ---------------- */
  qsa('[data-slideshow]').forEach(function (slideshow) {
    var slides = qsa('.hero-slide', slideshow);
    if (slides.length < 2) return;
    var dotsWrap = qs('.hero-dots', slideshow);
    var index = 0;
    var timer;
    var autoplay = slideshow.dataset.autoplay === 'true';
    var interval = parseInt(slideshow.dataset.interval || '6000', 10);

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        if (i === 0) dot.className = 'is-active';
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function render() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      if (dotsWrap) qsa('button', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function goTo(i) { index = (i + slides.length) % slides.length; render(); resetTimer(); }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function resetTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
    }
    on(slideshow, 'click', '.hero-arrow--next', next);
    on(slideshow, 'click', '.hero-arrow--prev', prev);
    render();
    resetTimer();
  });

  /* ---------------- Countdown timers ---------------- */
  qsa('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.innerHTML = '<span>00</span><span>00</span><span>00</span>'; return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      el.innerHTML = '<span>' + pad(h) + '</span><span>' + pad(m) + '</span><span>' + pad(s) + '</span>';
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  });

  /* ---------------- Product gallery ---------------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    on(gallery, 'click', '[data-thumb]', function (e, thumb) {
      var mediaId = thumb.dataset.thumb;
      qsa('.product-gallery__main img', gallery).forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.mediaId === mediaId);
      });
      qsa('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  /* ---------------- Theme product: desktop/mobile device toggle ---------------- */
  qsa('[data-device-gallery]').forEach(function (gallery) {
    on(gallery, 'click', '[data-device]', function (e, btn) {
      var device = btn.dataset.device;
      qsa('[data-device]', gallery).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      qsa('[data-device-panel]', gallery).forEach(function (panel) {
        panel.hidden = panel.dataset.devicePanel !== device;
      });
    });
    on(gallery, 'click', '[data-thumb]', function (e, thumb) {
      var target = thumb.dataset.thumb;
      var panel = thumb.closest('[data-device-panel]');
      qsa('img', panel).forEach(function (img) {
        if (img.dataset.thumbTarget) img.classList.toggle('is-active', img.dataset.thumbTarget === target);
      });
      qsa('[data-thumb]', panel).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  /* ---------------- Variant / option selection ---------------- */
  qsa('[data-product-form]').forEach(function (form) {
    var variantsJSON = form.querySelector('[data-variants-json]');
    if (!variantsJSON) return;
    var variants = JSON.parse(variantsJSON.textContent);
    var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

    function getSelectedOptions() {
      return qsa('[data-option-index]', form).map(function (group) {
        var active = qs('.is-active', group);
        return active ? active.dataset.value : null;
      });
    }
    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }
    function updateUI(variant) {
      var priceEl = qs('[data-product-price]', form);
      var comparePriceEl = qs('[data-product-compare-price]', form);
      var atcBtn = qs('[data-add-to-cart]', form);
      var buyNowBtn = qs('[data-buy-now]', form);
      var idInput = qs('[name="id"]', form);
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = atcBtn.dataset.soldOutText || 'Unavailable'; }
        if (buyNowBtn) { buyNowBtn.disabled = true; buyNowBtn.textContent = buyNowBtn.dataset.soldOutText || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (comparePriceEl) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = (atcBtn.dataset.addText || 'Add to Cart') + ' — ' + shortMoney(variant.price, moneyFormat);
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = atcBtn.dataset.soldOutText || 'Sold Out';
        }
      }
      if (buyNowBtn) {
        if (variant.available) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = (buyNowBtn.dataset.buyText || 'Buy Now') + ' — ' + shortMoney(variant.price, moneyFormat);
        } else {
          buyNowBtn.disabled = true;
          buyNowBtn.textContent = buyNowBtn.dataset.soldOutText || 'Sold Out';
        }
      }
      var mainImgId = variant.featured_media_id;
      if (mainImgId) {
        qsa('.product-gallery__main img').forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.mediaId === String(mainImgId));
        });
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    on(form, 'click', '.option-value', function (e, btn) {
      var group = btn.closest('[data-option-index]');
      qsa('.option-value', group).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var label = qs('[data-selected-value]', group);
      if (label) label.textContent = btn.dataset.value;
      updateUI(findVariant(getSelectedOptions()));
    });

    /* Quantity selector */
    on(form, 'click', '[data-qty-decrease]', function () {
      var input = qs('[data-qty-input]', form);
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    on(form, 'click', '[data-qty-increase]', function () {
      var input = qs('[data-qty-input]', form);
      input.value = parseInt(input.value || '1', 10) + 1;
    });

    /* Submit -> AJAX add to cart (opens the cart drawer) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = qs('[data-add-to-cart]', form);
      if (btn) btn.classList.add('btn--loading');
      var formEl = form.querySelector('form') || form;
      var formData = new FormData(formEl);
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCartDrawer(); })
        .then(function () {
          if (btn) btn.classList.remove('btn--loading');
          var drawer = qs('#cart-drawer');
          if (drawer) openDrawer(drawer);
        })
        .catch(function () { if (btn) btn.classList.remove('btn--loading'); });
    });

    /* Buy Now -> add this form's current product/variant to cart, then go straight to checkout.
       Independent of the Add to Cart submit handler above: this button is type="button" so it
       never triggers the form's submit event, and Add to Cart never triggers this handler. Both
       read the SAME dynamic hidden #id input on THIS product's own form, so each product page
       always checks out its own correct variant — nothing hardcoded. */
    on(form, 'click', '[data-buy-now]', function (e, btn) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.classList.add('btn--loading');
      var formEl = form.querySelector('form') || form;
      var formData = new FormData(formEl);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) { return r.json().then(function (err) { throw err; }); }
          return r.json();
        })
        .then(function () {
          window.location.href = root + 'checkout';
        })
        .catch(function (err) {
          btn.classList.remove('btn--loading');
          /* eslint-disable-next-line no-console */
          console.error('Buy Now: unable to add to cart', err);
        });
    });
  });

  /* ---------------- Cart drawer (AJAX) ---------------- */
  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#cart-drawer');
        var currentDrawer = qs('#cart-drawer');
        if (newDrawer && currentDrawer) {
          var wasOpen = currentDrawer.classList.contains('is-open');
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.toggle('is-open', wasOpen);
        }
        var count = doc.querySelector('[data-cart-count]');
        qsa('[data-cart-count]').forEach(function (el) {
          if (count) { el.textContent = count.textContent; el.style.display = count.textContent === '0' ? 'none' : 'flex'; }
        });
      });
  }
  on(document, 'click', '[data-cart-remove]', function (e, btn) {
    e.preventDefault();
    updateCartLine(btn.dataset.cartRemove, 0);
  });
  on(document, 'click', '[data-cart-qty-decrease]', function (e, btn) {
    var input = qs('[data-cart-qty-input]', btn.closest('.cart-line'));
    var newQty = Math.max(0, parseInt(input.value, 10) - 1);
    input.value = newQty;
    updateCartLine(btn.dataset.key, newQty);
  });
  on(document, 'click', '[data-cart-qty-increase]', function (e, btn) {
    var input = qs('[data-cart-qty-input]', btn.closest('.cart-line'));
    var newQty = parseInt(input.value, 10) + 1;
    input.value = newQty;
    updateCartLine(btn.dataset.key, newQty);
  });
  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCartDrawer(); })
      .then(function () {
        if (qs('.cart-page')) window.location.reload();
      });
  }

  /* ---------------- Cart note ---------------- */
  var noteDebounce;
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteDebounce);
    var value = e.target.value;
    noteDebounce = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 300);
  });

  /* ---------------- Quick view modal ---------------- */
  var quickViewModal = qs('#quick-view-modal');
  on(document, 'click', '[data-quick-view]', function (e, btn) {
    e.preventDefault();
    var handle = btn.dataset.quickView;
    if (!quickViewModal) return;
    var body = qs('.modal__panel [data-quick-view-content]', quickViewModal);
    body.innerHTML = '<p class="visually-hidden">Loading…</p>';
    quickViewModal.classList.add('is-open');
    document.body.classList.add('no-scroll');
    fetch('/products/' + handle + '?view=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) { body.innerHTML = html; })
      .catch(function () { body.innerHTML = '<p>Unable to load product.</p>'; });
  });
  on(document, 'click', '.modal__close, .modal__overlay', function (e, target) {
    var modal = target.closest('.modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
  });

  /* ---------------- Complementary product upsell fallback ---------------- */
  (function complementaryFallback() {
    var wrap = qs('[data-complementary-products]');
    if (!wrap) return;
    var list = qs('[data-complementary-list]', wrap);
    if (!list || list.children.length > 0) return; // already populated from metafield
    var productId = wrap.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) { wrap.style.display = 'none'; return; }
        list.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<a href="' + p.url + '" class="product-upsell__item">' +
            (img ? '<img src="' + img + '" alt="">' : '') +
            '<div><div class="product-upsell__item-title">' + p.title + '</div>' +
            '<div class="price"><span class="price__regular">' + formatMoney(p.price) + '</span></div></div></a>';
        }).join('');
      })
      .catch(function () { wrap.style.display = 'none'; });
  })();

  /* ---------------- Related products (lazy-loaded section) ---------------- */
  qsa('[data-recommendations-url]').forEach(function (el) {
    fetch(el.dataset.recommendationsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-recommendations-wrapper]');
        var target = qs('[data-recommendations-wrapper]', el);
        if (content && target) target.innerHTML = content.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------------- Sticky add-to-cart ---------------- */
  (function stickyAtc() {
    var bar = qs('.sticky-atc');
    var form = qs('[data-product-form]');
    if (!bar || !form) return;
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(form);
    on(bar, 'click', '[data-sticky-add]', function () {
      var mainBtn = qs('[data-add-to-cart]', form);
      if (mainBtn) mainBtn.click();
    });
  })();

  /* ---------------- Scroll reveal ---------------- */
  (function reveal() {
    var items = qsa('[data-animate]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---------------- Predictive search (basic) ---------------- */
  var searchInput = qs('[data-search-input]');
  if (searchInput) {
    var resultsBox = qs('[data-search-results]');
    var debounceTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { if (resultsBox) resultsBox.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.js?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!resultsBox) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            resultsBox.innerHTML = products.map(function (p) {
              return '<a href="' + p.url + '" class="search-result">' +
                (p.image ? '<img src="' + p.image + '" alt="">' : '') +
                '<span>' + p.title + '</span></a>';
            }).join('') || '<p class="search-result--empty">No results</p>';
          });
      }, 250);
    });
  }
})();
